export function _isBoundOverlappingBound(item, bounds) {
    let width = item.width || 0;
    let height = item.height || 0;
    return !(item.x > bounds.x + bounds.width ||
        bounds.x > item.x + width ||
        item.y > bounds.y + bounds.height ||
        bounds.y > item.y + height);
}
export function boundsToQuery(bounds) {
    return {
        x: bounds.getSouthWest().lng,
        y: bounds.getSouthWest().lat,
        width: bounds.getNorthEast().lng - bounds.getSouthWest().lng,
        height: bounds.getNorthEast().lat - bounds.getSouthWest().lat,
    };
}
